<template>
    <div>
        <div class="bar" id="barId"></div>
        <img src="~@/assets/newHome/置顶.png" alt="" class="toTop" v-if="toTopShow" @click="toPageTop()">
        <div class="background">
            <img src="~@/assets/newHome/背景.png" alt="" class="picture">
            <div class="text1">遥感地信开发的新利器</div>
            <div class="text2">及时、优质、便捷，首选吉林一号切片影像套件<br>按需调用，精准付费，数据安全可靠<br>大跨步实现高质量卫星遥感影像自由</div>
            <div class="text3">切片套件采购详询商务经理：0431-86008580</div>
            <div class="white">
                <!-- <img src="~@/assets/newHome/切换器右_black.png" alt="" v-if="canTurn" @click="turnPosition(1)" style="position: absolute;top: 58px;right: 41px;cursor: pointer;">
                <img src="~@/assets/newHome/切换器左_black.png" alt="" v-if="!canTurn" @click="turnPosition(2)" style="position: absolute;top: 58px;left: 41px;cursor: pointer;"> -->
                <div class="contentMove">
                    <div class="content1">
                        <img src="../assets/price/体验版.png" alt="" class="content1Img1">
                        <!-- <div class="content1Text1">体验版</div>
                        <div class="content1Text2">限时免费</div>
                        <div class="coontent1Line"></div> -->
                        <div class="content1Text3">适用于个人开发者或机构体验测试</div>
                        <div class="content1Button" style="background:linear-gradient( 107deg, #c8c8c9 0%, #535354 100%);" @click="goPurchase(1)"><span v-if="basisStatus">立即查看</span><span v-else>免费申请</span></div>
                    </div>
                    <!-- <div class="content1">
                        <div class="content1Text1">企业版</div>
                        <div class="content1Text2">卫星影像自由</div>
                        <div class="coontent1Line"></div>
                        <div class="content1Text3">适用于中小微企、教科研机构</div>
                        <div class="content1Button" style="background: linear-gradient(107deg, #54A7FF 0%, #1E81EB 100%);" @click="goPurchase(2)">购买企业版</div>
                    </div> -->

                    <div class="content1">
                        <img src="../assets/price/标准版.png" alt="" class="content1Img1">
                        <!-- <div class="content1Text1">图商版</div>
                        <div class="content1Text2">详询商务经理</div>
                        <div class="coontent1Line"></div> -->
                        <div class="content1Text3">适用于全国范围卫星底图调用</div>
                        <div class="content1Button" style="background:linear-gradient( 107deg, #5d7286 0%, #20282f 100%);" @click="goPurchase(5);">购买标准版</div>
                    </div>
                  <div class="content1">
                    <img src="../assets/price/专业版.png" alt="" class="content1Img1">
                    <!-- <div class="content1Text1">专业版</div>
                    <div class="content1Text2">仅为所用付费</div>
                    <div class="coontent1Line"></div> -->
                    <div class="content1Text3">适用于局部区域最新影像调用</div>
                    <div class="content1Button" style="background:linear-gradient( 107deg, #D0A054 0%, #925C31 100%);" @click="goPurchase(3)">购买专业版</div>
                  </div>
                </div>
                <!-- 数据源 -->
                <div class="whiteLine">
                    <div class="whiteLine1"></div>
                    <div class="whiteLineText">数据源</div>
                    <div class="whiteLine2"></div>
                </div>
                <div class="contentMove" style="height: 720px;">
                  <div class="content2">
                        <div class="content2Text1">2024年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">全国高质量一张图</div>
                        </div>
                        <div class="content2Text1" style="margin-top:40px ;">2023年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">全国高质量一张图</div>
                        </div>
                        <div class="content2Text1" style="margin-top:40px ;">2022年度</div>
                        <!-- <div class="content2None"></div> -->
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">全球一张图</div>
                        </div>
                        <!-- <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">每季度试点县域一张图</div>
                        </div> -->
                    </div>
                  <div class="content2" style="margin-left: 100px;">
                    <div class="content2Text1">2024年度</div>
                    <div class="content2Text2">
                        <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                        <div class="content2Text21">全国高质量一张图</div>
                    </div>
                    <div class="content2Text1" style="margin-top:40px ;">2023年度</div>
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">全国高质量一张图</div>
                    </div>
                    <div class="content2Text1" style="margin-top:40px ;">2022年度</div>
                    <!-- <div class="content2None"></div> -->
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">全国高质量一张图</div>
                    </div>
                  </div>
                  <div class="content2" style="margin-left: 100px;">
                        <div class="content2Text1" style="background: linear-gradient( 90deg, #FDEAC6 0%, #F4C89A 100%);color: #996435;">2026年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">每季度全国一张图</div>
                            <div class="content2TextSmall" style="left: 155px">1</div>
                        </div>
                        <div class="content2Text1" style="margin-top:40px;background: linear-gradient( 90deg, #FDEAC6 0%, #F4C89A 100%);color: #996435;">2025年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">每两个月全国一张图</div>
                        </div>
                        <div class="content2Text1" style="margin-top:40px;background: linear-gradient( 90deg, #FDEAC6 0%, #F4C89A 100%);color: #996435;">2024年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">每季度全国一张图</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">全国高质量一张图</div>
                        </div>
                        <div class="content2Text1" style="margin-top:40px;background: linear-gradient( 90deg, #FDEAC6 0%, #F4C89A 100%);color: #996435;">2023年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">每季度全国一张图</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">全国高质量一张图</div>
                        </div>
                        <div class="content2Text1" style="margin-top:40px;background: linear-gradient( 90deg, #FDEAC6 0%, #F4C89A 100%);color: #996435;">2022年度</div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">全球一张图</div>
                        </div>
                        <!-- <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">每季度试点县域一张图</div>
                        </div> -->
                    </div>
                </div>
                <!-- 数据参数 -->
                <div class="whiteLine">
                    <div class="whiteLine1" style="width: 515px;"></div>
                    <div class="whiteLineText">数据参数</div>
                    <div class="whiteLine2" style="width: 515px;"></div>
                </div>
                <div class="contentMove" style="height: 400px;">
                    <div class="content2" style="margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">分辨率优于 0.75m (含)，最高可达0.5m</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">切片等级：1 ~ 18级</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">有效数据覆盖率：</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2024年全国一张图</div>
                            <div class="content2Text22">99%</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2023年全国一张图</div>
                            <div class="content2Text22">99%</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">全球一张图</div>
                            <div class="content2Text22">>85%</div>
                        </div>
                        <!-- <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2022年每季度试点县县域一张图</div>
                            <div class="content2Text22">100%</div>
                        </div> -->
                    </div>
                  <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">分辨率优于 0.75m (含)，最高可达0.5m</div>
                    </div>
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">切片等级：1 ~ 18级</div>
                    </div>
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">有效数据覆盖率：</div>
                    </div>
                    <div class="content2Text2" style="margin-top: 12px;">
                      <div class="content2Text21">2024年全国一张图</div>
                      <div class="content2Text22">99%</div>
                    </div>
                    <div class="content2Text2" style="margin-top: 12px;">
                      <div class="content2Text21">2023年全国一张图</div>
                      <div class="content2Text22">99%</div>
                    </div>
                    <div class="content2Text2" style="margin-top: 12px;">
                      <div class="content2Text21">2022年全国一张图</div>
                      <div class="content2Text22">99%</div>
                    </div>

                  </div>

                  <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">分辨率优于 0.75m (含)，最高可达0.5m</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">切片等级：1 ~ 18级</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">有效数据覆盖率：</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2024年全国一张图</div>
                            <div class="content2Text22">99%</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2023年全国一张图</div>
                            <div class="content2Text22">99%</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">全球一张图</div>
                            <div class="content2Text22">>85%</div>
                        </div>
                        <!-- <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2022年每季度试点县县域一张图</div>
                            <div class="content2Text22">100%</div>
                        </div> -->
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2023/2024年每季度自选区域一张图</div>
                            <div class="content2Text22">≥90%</div>
                            <div class="content2TextSmall" style="left: 258px;">2</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2025年每两个月自选区域一张图</div>
                            <div class="content2Text22">≥90%</div>
                        </div>
                        <div class="content2Text2" style="margin-top: 12px;">
                            <div class="content2Text21">2026年每季度自选区域一张图</div>
                            <div class="content2Text22">≥90%</div>
                            <!-- <div class="content2TextSmall" style="left: 258px;">2</div> -->
                        </div>
                    </div>
                </div>
                <!-- 请求次数限制 -->
                <div class="whiteLine">
                    <div class="whiteLine1" style="width: 500px;"></div>
                    <div class="whiteLineText">请求次数限制</div>
                    <div class="whiteLine2" style="width: 500px;"></div>
                </div>
                <div class="contentMove" style="height: 215px;">
                    <div class="content2" style="margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">单日限额</div>
                            <div class="content2Text22">前7日10万次，之后4万次</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">总限额</div>
                            <div class="content2Text22">无限制</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">并发限制</div>
                            <div class="content2Text22">30次/s</div>
                        </div>
                    </div>
                    <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">单日限额</div>
                            <div class="content2Text22">50万次/300万次</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">总限额</div>
                            <div class="content2Text22">无限制</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">并发限制</div>
                            <div class="content2Text22">300次/s</div>
                        </div>
                    </div>
                    <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">单日限额</div>
                      <div class="content2Text22">16万次</div>
                      <div class="content2TextSmall" style="left: 312px;">3</div>
                    </div>
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">总限额</div>
                      <div class="content2Text22">无限制</div>
                    </div>
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                      <div class="content2Text21">并发限制</div>
                      <div class="content2Text22">100次/s</div>
                    </div>
                  </div>
                </div>
                <!-- 套件工具 -->
                <div class="whiteLine">
                    <div class="whiteLine1" style="width: 510px;"></div>
                    <div class="whiteLineText">套件工具</div>
                    <div class="whiteLine2" style="width: 510px;"></div>
                </div>
                <div class="contentMove" style="height: 260px;">
                    <div class="content2" style="margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号智慧工作台Online</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号桌面客户端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号移动端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号应用工具箱SDK</div>
                        </div>
                    </div>
                    <!-- <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号智慧工作台Online</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号桌面客户端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号移动端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号应用工具箱SDK</div>
                        </div>
                    </div> -->
                    <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号智慧工作台Online</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号桌面客户端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号移动端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号应用工具箱SDK</div>
                        </div>
                    </div>
                    <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号智慧工作台Online</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号桌面客户端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号移动端软件</div>
                        </div>
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">吉林一号应用工具箱SDK</div>
                        </div>
                    </div>
                </div>
                <!-- 商用授权书 -->
                <div class="whiteLine">
                    <div class="whiteLine1" style="width: 510px;"></div>
                    <div class="whiteLineText">商用授权书</div>
                    <div class="whiteLine2" style="width: 510px;"></div>
                </div>
                <div class="contentMove" style="height: 125px;">
                    <div class="content2" style="margin-top: 24px;">
                        <div class="content2Text2">
                            <div class="content2None">—</div>
                        </div>
                    </div>
                    <!-- <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">可申请吉林一号数据商用授权书</div>
                            <div class="content2TextSmall" style="left: 228px;">4</div>
                        </div>
                    </div> -->
                    <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">可申请吉林一号数据商用授权书</div>
                            <div class="content2TextSmall" style="left: 228px;">4</div>
                        </div>
                    </div>
                    <div class="content2" style="margin-left: 100px;margin-top: 24px;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/icon1.png" alt="" class="content2Icon">
                            <div class="content2Text21">可申请吉林一号数据商用授权书</div>
                            <!-- <div class="content2TextSmall" style="left: 228px;">6</div> -->
                        </div>
                    </div>
                </div>
                <!-- 套件价格 -->
                <div class="whiteLine">
                    <div class="whiteLine1" style="width: 510px;"></div>
                    <div class="whiteLineText">套件价格</div>
                    <div class="whiteLine2" style="width: 510px;"></div>
                </div>
                <div class="contentMove" style="height: 260px;">
                    <div class="content2" style="margin-top: 24px;position: relative;">
                        <div class="content2Text2">
                            <img src="~@/assets/newHome/限时免费.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">
                            <div class="content2Text21">限时免费</div>
                        </div>
                        <div class="content2Button" style="background:linear-gradient( 107deg, #c8c8c9 0%, #535354 100%);" @click="goPurchase(1)"><span v-if="basisStatus">立即查看</span><span v-else>免费申请</span></div>
                    </div>

                    <div class="content2" style="margin-left: 100px;margin-top: 24px;position: relative;">
                      <div class="content2Text2" style="margin-left: 0px">
                          <img src="~@/assets/newHome/套件价格.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">
                          <div class="content2Text21" style="width: 420px;">2024年全国高质量一张图：￥18.8万/年 起</div>
                          <!-- <div class="content2Text22">以查询结果为准</div> -->
                      </div>
                      <div class="content2Text2" style="margin-left: 0px;margin-top: 15px;">
                        <img src="~@/assets/newHome/套件价格.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">
                        <div class="content2Text21" style="width: 420px;">2023年全国高质量一张图：￥16.8万/年 起</div>
                        <!-- <div class="content2Text22">以查询结果为准</div> -->
                      </div>
                      <div class="content2Text2" style="margin-left: 0px;margin-top: 15px;">
                        <img src="~@/assets/newHome/套件价格.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">
                        <div class="content2Text21" style="width: 420px;">2022年全国高质量一张图：￥16.8万/年 起</div>
                        <!-- <div class="content2Text22">以查询结果为准</div> -->
                      </div>
<!--                      <div class="content2Text2" style="margin-left: -60px;margin-top: 15px;">-->
<!--                        <img src="~@/assets/newHome/套件价格.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">-->
<!--                        <div class="content2Text21" style="width: 420px;">2022年全国高质量一张图（调用次数300万次/日）￥44.8万/年</div>-->
<!--                        &lt;!&ndash; <div class="content2Text22">以查询结果为准</div> &ndash;&gt;-->
<!--                      </div>-->
                        <div class="content2Button" style="background:linear-gradient( 107deg, #5d7286 0%, #20282f 100%);" @click="goPurchase(5);">购买标准版</div>
                    </div>
                  <div class="content2" style="margin-left: 100px;margin-top: 24px;position: relative;">
                    <div class="content2Text2">
                      <img src="~@/assets/newHome/套件价格.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">
                      <div class="content2Text21" style="width: 320px;">2023/2024/2025/2026全年任意单期：以查询结果为准</div>
                      <!-- <div class="content2Text22">以查询结果为准</div> -->
                    </div>
                    <div class="content2Button" style="background:linear-gradient( 107deg, #D0A054 0%, #925C31 100%);"  @click="goPurchase(3)">购买专业版</div>
                  </div>
<!--                    <div class="content2" style="margin-left: 100px;margin-top: 24px;position: relative;">-->
<!--                        <div class="content2Text2">-->
<!--                            <img src="~@/assets/newHome/套件价格.png" alt="" class="content2Icon" style="width: 15px;height: 19px;">-->
<!--                            <div class="content2Text21">详询商务经理</div>-->
<!--                            &lt;!&ndash; <div class="content2Text22">￥220万/年</div> &ndash;&gt;-->
<!--                        </div>-->
<!--                        <div class="content2Button" style="background: #FFFFFF;border: 1px solid #5DA9DC;color:  #5DA9DC;" @click="connectStatus=true">联系我们</div>-->
<!--                    </div>-->

                </div>
            </div>
            <div class="specialInstruction">
                <div class="specialText1">特别说明</div>
                <div class="specialText2">1. 区域限制：订购区域支持选择行政区划、绘制范围、上传矢量文件（kml、shp文件），绘制范围或上传矢量文件情况下的最小单个闭合图斑面积100平方公里，单个闭合图斑面积最小宽度5公里；</div>
                <div class="specialText2" style="top: 150px;">2. 服务期说明：专业版有效期为一年，例如：2025年3月10日购买，有效期至2026年3月10日；</div>
                <div class="specialText2" style="top: 185px;">3. 购买专业版用户可申请吉林一号数据商用授权书，授权其开展订购区域投标等商用业务。</div>
                <div class="specialText2" style="top: 220px;">4. 吉林一号切片影像套件的最终解释权归长光卫星技术股份有限公司所有。</div>
            </div>
            <div class="contractUs">
                <img src="~@/assets/newHome/首页联系我们.png" alt="" class="contractUsImg">
                <div class="contractText1">仍有困惑？我们很乐于帮忙！</div>
                <div class="contractText2">对吉林一号切片影像套件仍有疑问? 我们的技术团队会提供帮助。</div>
                <div class="contractButton" @click="connectStatus=true">联系我们</div>
            </div>
        </div>
        <div class="note">
            <div class="noteText">1、每季度第十日更新上季度全国一张图，东起中朝边境鸭绿江口至中越边界北仑河口的陆地边界向内5km范围为限制区域，如需选购须提交申请说明。部分敏感区域数据暂不对外开放。</div>
            <div class="noteText" style="margin-top: 10px;">2、无云数据的面积占比（部分敏感区域除外）。</div>
            <!-- <div class="noteText" style="margin-top: 10px;">3、用户可任意选择采购区域，支持按省市县等行政区划选择或自定义上传边界文件（kml、shp文件），最小单个闭合边界文件面积100平方公里，单个闭合边界文件最小宽度5公里，单个套餐内选购总面积不超过10万平方公里。</div> -->
            <!-- <div class="noteText" style="margin-top: 10px;">4、支持离线下载所订购区域内的实体切片数据，最小起订面积100平方公里，价格为1元/平方公里。</div>
            <div class="noteText" style="margin-top: 10px;">5、超过套餐调用次数可选购流量加油包，1万元/500万次，可叠加购买。</div> -->
            <div class="noteText" style="margin-top: 10px;">3、专业版套件固定为16万次/日，其他图源（2022年度全球一张图、2023年度全国一张图、2024年度全国一张图）前7日10万次/日，7日之后4万次/日。</div>
            <div class="noteText" style="margin-top: 10px;">4、需向商务经理申请。</div>
            <div class="noteLine"></div>
        </div>
        <div class="shadow" v-if="connectStatus">
            <div class="dialog2" >
                <img src="~@/assets/newHome/关闭.png" alt="" class="dialogImg1" @click="connectStatus=false"/>
                <p class="dialogText1">请联系我们的商务经理咨询更多详情</p>
                <img src="~@/assets/newHome/电话.png" alt="" class="dialogImg2" />
                <span class="dialogText2">0431-86008580</span>
                <div class="dialogText3">( 非节假日 08:30 ~ 17:30 )</div>
                <img src="~@/assets/newHome/邮箱.png" alt="" class="dialogImg2" style="top: 220px;"/>
                <span class="dialogText4">jl1mall@jl1.cn</span>
                <button class="hideToConsultation" @click="connectStatus=false">
                关闭
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import {rootUrl} from '@/globalConfig'
export default {
    name:"Price",
    data(){
        return{
            toTopShow:true,
            connectStatus:false,
            canTurn:true,
            basisStatus:false

        }
    },
    methods:{
        getKey() {
            return localStorage.getItem("token");
        },
        //带权限判断的跳转
        jumpWithPermission(type,path,fromUrl){
            //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
            //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
            let loginUserId=localStorage.getItem('userId');//是否已登录
            let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
            if(type=='可游客'){
                if(fromUrl){
                    window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                }
                else {
                    window.open(rootUrl+path,"_self")
                }
            }else if(type=='仅登录'){
                //已登录
                if(loginUserId){
                    if(fromUrl){
                        window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+path,"_self")
                    }
                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }else if(type=='仅实名'){
                //已登录
                if(loginUserId){
                    //已实名
                    if(authentication=='0'){
                        if(fromUrl){
                            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
                        }
                        else {
                            window.open(rootUrl+path,"_self")
                        }
                    }
                    //未实名
                    else {
                        window.open(rootUrl+'/Authentication',"_self")
                    }

                }
                //未登录
                else {
                    if(fromUrl){
                        window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
                    }
                    else {
                        window.open(rootUrl+'/Login',"_self")
                    }
                }
            }
        },
        getToTop(){
            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop
            let windowHeight = document.documentElement.scrollHeight || document.body.scrollHeight
            if(scrollHeight>=windowHeight*0.6){
                this.toTopShow=true
            }else{
                this.toTopShow=false
            }
        },
        turnPosition(i){
            if(i==1){
                let contentMove = document.getElementsByClassName("contentMove")
                for(let i=0;i<contentMove.length;i++){
                    contentMove[i].style.marginLeft='-335px'
                }
                this.canTurn=false
            }else if(i==2){
                let contentMove = document.getElementsByClassName("contentMove")
                for(let i=0;i<contentMove.length;i++){
                    contentMove[i].style.marginLeft='75px'
                }
                this.canTurn=true
            }

        },
        goPurchase(i) {
            let url = "/Price"
            if(this.$store.state.user.authentication==0){
                this.orderStatus(i)
            }else{
                if(this.$store.state.user.logined){
                    this.jumpWithPermission('仅实名','/Authentication','/rskit/Price')
                }else{
                    this.$router.push({path: "/Login",query: {'returnUrl':url}});
                }
            }
        },
        getUserData(){
            if(this.$store.state.county.name==''||this.$store.state.county.name==null){
                return false
            }else if(this.$store.state.county.age==''||this.$store.state.county.age==null){
                return false
            }else if(this.$store.state.county.sex==''||this.$store.state.county.sex==null){
                return false
            }else if(this.$store.state.county.company==''||this.$store.state.county.company==null){
                return false
            }else if(this.$store.state.county.education==''||this.$store.state.county.education==null){
                return false
            }else{
                return true
            }
        },
        //查询订单当前状态
        orderStatus(i){

            this.axios.post("/tilesapi/tiles/register/queryTileOrderStatus",null, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res)=>{
                let data = res.data.data
                if(i==1){
                    if(!data.includes('体验版')){
                    this.$router.push({path: "/Purchase",query: {'processType':1}});
                    }else{
                    this.$router.push("/MyRSservices");
                    }
                }else if(i==3){
                    if(!data.includes('体验版')){
                        if(!this.getUserData()){
                        this.$router.push({path: "/Purchase",query: {'processType':7}});
                        }else{
                        this.$router.push('/buyCountyProduction');
                        }
                    }else{
                        if(!this.getUserData()){
                        this.$router.push({path: "/Purchase",query: {'processType':8}});
                        }else{
                        this.$router.push('/buyCountyProduction');
                        }
                    }
                }
                //标准版
                else if(i==5){
                  this.$router.push({path: "/Purchase",query: {'processType':11}});
                }
            })
        },
        toPageTop(){
            document.getElementById('barId').scrollIntoView({ behavior: "smooth"});
        },
        //查询用户是否申请过体验版
        basisApplyStatus(){
            this.axios.post("/tilesapi/tiles/register/queryTileOrderStatus",null, {
                headers: {
                Authorization: "Bearer " + this.getKey(),
                },
            }).then((res)=>{
                console.log(res);
                let data = res.data.data
                if(data.includes('体验版')){
                    this.basisStatus=true
                }else{
                    this.basisStatus=false
                }
            })
        }
    },
    mounted(){
        document.getElementById('barId').scrollIntoView({ behavior: "instant"});
        window.addEventListener('scroll', this.getToTop, true)
        this.basisApplyStatus()
    }

}
</script>

<style scoped>
.toTop{
    position: fixed;
    right: 20px;
    bottom: 20px;
    width: 58px;
    height: 58px;
    cursor: pointer;
    z-index: 20000001;
}
.bar{
    position: relative;
    width: 100%;
    height: 76px;
    background-color: #fff;
}
.background{
    position: relative;
    width: 100%;
    height: auto;
    background-color: #fff;
    overflow: hidden;
    padding-bottom:100px;
    min-height: 2000px;
}
.picture{
    position: absolute;
    width: 100%;
    height: 960px;
}
.text1{
    position: absolute;
    top: 125px;
    left: calc(50% - 180px);
    width: 360px;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #3A3A3A;
    line-height: 42px;
    text-align: center;
}
.text2{
    position: absolute;
    top: 197px;
    left: calc(50% - 200px);
    width: 400px;
    height: 90px;
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #3A3A3A;
    line-height: 30px;
    text-align: center;
}
.text3{
    position: absolute;
    top: 337px;
    left: calc(50% - 400px);
    width: 800px;
height: 16px;
font-size: 16px;
font-family: PingFangSC-Light, PingFang SC;
font-weight: 300;
color: #3A3A3A;
line-height: 16px;
text-align: center;

}
.white{
    position: relative;
    margin-top: 412px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 2400px;
    background: #FFFFFF;
    box-shadow: 0px 1px 5px 0px rgba(0,0,0,0.15);
    border: 1px solid #EAEAEA;
    border-radius: 16px;
    overflow: hidden;
    }
    .contentMove{
        margin-left:75px;
        width: 1640px;
        height: 358px;
        background-color: #fff;
        overflow: hidden;
        /* background-color: green; */
    }
.content1{
    float: left;
    margin-right: 100px;
    width: 310px;
    height: 358px;
    /* background-color: pink; */
    overflow: hidden;
}
.content1Img1{
    display: block;
    margin-top: 55px;
    margin-left: 0;
    width: 310px;
}
.content1Text1{
    margin-top: 55px;
    margin-left: 0;
    width:60px;
    height: 25px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1E81EB;
    line-height: 25px;
}
.content1Text2{
    margin-top: 3px;
    margin-left: 0;
    width: 310px;
height: 42px;
font-size: 30px;
font-family: PingFangSC-Semibold, PingFang SC;
font-weight: 600;
color: #3A3A3A;
line-height: 42px;
}
.coontent1Line{
margin-top: 39px;
margin-left: 0;
width: 310px;
height: 1px;
background-color: rgba(0,0,0,0.25);
}
.content1Text3{
    margin-top: 19px;
    margin-left: 0;
    width: 310px;
height: 22px;
font-size: 16px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #777777;
line-height: 22px;
}
.content1Button{
    margin-top: 50px;
    margin-left: 0;
    width: 310px;
height: 52px;
background: #3A3A3A;
border-radius: 8px;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 52px;
text-align: center;
cursor: pointer;
}
.whiteLine{
    position: relative;
    float: left;
    margin-top: 0;
    margin-left: 76px;
   width: 1130px;
   height: 25px;
   /* background-color: seagreen; */
}
.whiteLine1{
    position: absolute;
    top: 13px;
    left: 0;
    width: 527px;
    height: 1px;
    border-bottom: 1px dashed rgba(0,0,0,0.3);

}
.whiteLine2{
    position: absolute;
    top: 13px;
    right: 0;
    width: 527px;
    height: 1px;
    border-bottom: 1px dashed rgba(0,0,0,0.3);

}
.whiteLineText{
    position: absolute;
    top: 1px;
    left: calc(50% - 150px);
    margin-right: 11px;
    width: 300px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 25px;
text-align: center;
}
.content2{
    float: left;
    width: 310px;
    height: auto;
    margin-top: 50px;
    background-color: #fff;
}
.content2Text1{
    margin-top: 0;
    margin-left: 0;
    width: 95px;
height: 30px;
background: #F5F5F6;
border-radius: 18px;
font-size: 14px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #777777;
line-height: 30px;
text-align: center;
}
.content2Text2{
    position: relative;
    width: 310px;
    height: 18px;
    margin-top: 26px;
}
.content2Icon{
    position: absolute;
    width: 18px;
    height: 18px;
    left: 0;

}
.content2Text21{
    position: absolute;
    left: 28px;
    width: 280px;
    height: 18px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    line-height: 18px;
}
.content2Text22{
    position: absolute;
    right: 0;
    width:200px;
    height: 18px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    line-height: 18px;
    text-align: right;
}
.content2TextSmall{
    position: absolute;
    left: 199px;
    top: -5px;
    width: 12px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 17px;
}
.content2None{
    margin-top: 25px;
    margin-left: 0;
    width: 14px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000;
    line-height: 20px;
}
.content2Button{
    position: absolute;
    top: 175px;
    width: 310px;
    height: 52px;
    background: #3A3A3A;
    border-radius: 8px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 52px;
    text-align: center;
    cursor: pointer;
}
.specialInstruction{
    position: relative;
    margin-top:100px;
   margin-left: calc(50% - 640px);
    width: 1280px;
    height: 300px;
    background: linear-gradient(127deg, #774048 0%, #161B45 100%, #9B4D49 100%);
    border-radius: 32px;
}
.specialText1{
    position: absolute;
    top: 50px;
    left: calc(50% - 50px);
    width: 100px;
height: 25px;
font-size: 18px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 25px;
text-align: center;
}
.specialText2{
    position: absolute;
    top: 115px;
    left: 40px;
    width: 1220px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #FFFFFF;
line-height: 20px;
}
.contractUs{
    position: relative;
    margin-top:100px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 400px;
}
.contractUsImg{
    position: absolute;
    width: 600px;
    height: 200px;
    top: 0;
    left: calc(50% - 300px);
}
.contractText1{
    position: absolute;
    top: 228px;
    left: calc(50% - 200px);
    width: 400px;
height: 37px;
font-size: 26px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #363F53;
line-height: 37px;
text-align: center;
}
.contractText2{
    position: absolute;
    top: 292px;
    left: calc(50% - 300px);
    width:600px;
height: 18px;
font-size: 18px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #363F53;
line-height: 18px;
text-align: center;
}
.contractButton{
    position: absolute;
    top: 350px;
    left: calc(50% - 64px);
    width: 128px;
height: 44px;
background: #FFFFFF;
border-radius: 22px;
border: 1px solid #3A3A3A;
font-size: 16px;
font-family: PingFangSC-Medium, PingFang SC;
font-weight: 500;
color: #3A3A3A;
line-height: 44px;
text-align: center;
cursor: pointer;

}
.note{
    position: relative;
    width: 100%;
    height:210px;
    background: #F7F9FC;
    overflow: hidden;
}
.noteText{
    margin-top: 50px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 17px;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #3A3A3A;
    line-height: 17px;

}
.noteLine{
    margin-top: 69px;
    margin-left: calc(50% - 640px);
    width: 1280px;
    height: 1px;
    background-color:  #979797;
    opacity: 0.6;
}
.noteFooter{
    margin-top: 52px;
    margin-left: calc(50% - 300px);
    width: 600px;
height: 17px;
font-size: 12px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #3A3A3A;
line-height: 17px;
text-align: center;
}
.shadow{
  position: fixed;
  top: 0;
  width: 100%;
  height:100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 10000;
}
.dialog2 {
    position: absolute;
  width: 600px;
  height: 400px;
  border-radius: 16px;
  left: calc(50% - 300px);
  top: calc(50% - 200px);
  z-index: 10001;
  background: #ffffff;
}
.dialogImg1{
    position: absolute;
    top: 0;
    right: -50px;
    cursor: pointer;
}
.dialogText1 {
    position: absolute;
  top: 69px;
  left: calc(50% - 300px);
  width: 600px;
  height: 24px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #1d1d28;
  line-height: 25px;
  text-align: center;
}
.dialogImg2{
    position: absolute;
    left: 156px;
    top: 144px;
}
.dialogText2 {
 position: absolute;
 top: 140px;
  left: 190px;
  width: 300px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #1d1d28;
  line-height: 22px;
}
.dialogText3 {
    position: absolute;
    top: 165px;
    left: 190px;
  width: 208px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #1d1d28;
  line-height: 22px;
  text-align: center;
}
.dialogText4 {
position: absolute;

top: 214px;
    left: 190px;
  width: 120px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #1d1d28;
  line-height: 22px;
}
.hideToConsultation {
position: absolute;
left: calc(50% - 48px);
top: 300px;
  width: 96px;
  height: 44px;
  background: #1E81EB;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
</style>
